import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
    { label: "Servizi", id: "servizi" },
    { label: "Perché noi", id: "perche-noi" },
    { label: "Offerte", id: "catalogo" },
    { label: "Chi siamo", id: "chi-siamo" },
    { label: "Contatti", id: "contatti" },
];

export default function Nav() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    return (
        <header className="fixed inset-x-0 top-0 z-50 bg-background/80 backdrop-blur-xl border-b border-line">
            <div className="mx-auto max-w-7xl px-5 sm:px-8 h-[72px] flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    className="shrink-0"
                    aria-label="CG Service SRL — home"
                >
                    <Logo />
                </a>

                <nav className="hidden lg:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <a
                            key={l.id}
                            href={`#${l.id}`}
                            data-testid={`nav-link-${l.id}`}
                            className="font-mono text-[11px] tracking-[0.22em] uppercase text-muted-foreground hover:text-foreground transition-colors duration-200"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-3">
                    <a
                        href="tel:+390835981465"
                        data-testid="nav-phone"
                        className="flex items-center gap-2 border border-line px-4 py-2.5 font-mono text-xs text-foreground hover:border-primary hover:text-primary transition-colors duration-200"
                    >
                        <Phone className="h-3.5 w-3.5" />
                        0835 981465
                    </a>
                    <a
                        href="#catalogo"
                        data-testid="nav-cta"
                        className="bg-primary text-primary-foreground px-5 py-2.5 font-display font-bold text-sm tracking-tight hover:bg-primary/90 transition-colors duration-200"
                    >
                        Offerte del mese
                    </a>
                </div>

                <button
                    className="lg:hidden p-2 text-foreground"
                    onClick={() => setOpen(!open)}
                    data-testid="nav-menu-toggle"
                    aria-label="Apri menu"
                >
                    {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </button>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                        className="lg:hidden overflow-hidden bg-background/95 backdrop-blur-xl border-b border-line"
                    >
                        <nav className="flex flex-col px-5 py-6 gap-1">
                            {LINKS.map((l) => (
                                <a
                                    key={l.id}
                                    href={`#${l.id}`}
                                    onClick={() => setOpen(false)}
                                    data-testid={`nav-mobile-link-${l.id}`}
                                    className="py-3 border-b border-line font-display text-2xl font-bold tracking-tight text-foreground"
                                >
                                    {l.label}
                                </a>
                            ))}
                            <a
                                href="tel:+390835981465"
                                data-testid="nav-mobile-phone"
                                className="mt-4 flex items-center justify-center gap-2 bg-primary text-primary-foreground px-4 py-3.5 font-display font-bold"
                            >
                                <Phone className="h-4 w-4" />
                                Chiama 0835 981465
                            </a>
                        </nav>
                    </motion.div>
                )}
            </AnimatePresence>
        </header>
    );
}